// ** Dropdowns Imports
import IntlDropdown from "./IntlDropdown";
import CartDropdown from "./CartDropdown";
import UserDropdown from "./UserDropdown";
import NavbarSearch from "./NavbarSearch";
import NotificationDropdown from "./NotificationDropdown";
import { selectThemeColors } from '@utils'
import Select from 'react-select'

// ** Third Party Components
import { Sun, Moon } from "react-feather";

// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap";

import useCountryCode from "../../../../utility/hooks/useCountryCode";

const NavbarUser = (props) => {
  const { countryCode, countryCodes, setCountryCode } = useCountryCode();

  // ** Props
  const { skin, setSkin } = props;

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />;
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />;
    }
  };

  return (
    <ul className="nav navbar-nav align-items-center ms-auto">

      {/* <span className="user-name fw-bold" style={{ marginRight: 12, fontWeight: "bold" }}>Country</span> */}

      <div style={{ marginRight: 12 }}>
        <Select
          theme={selectThemeColors}
          className='react-select'
          classNamePrefix='select'
          isClearable={false}
          value={countryCodes.find((s) => s.value === countryCode)}
          onChange={(e) => setCountryCode(e.value)}
          defaultValue={countryCodes[0]}
          options={countryCodes}
        />
      </div>

      {/* <IntlDropdown /> */}

      <NavItem className="d-none d-lg-block">
        <NavLink className="nav-link-style">
          <ThemeToggler />
        </NavLink>
      </NavItem>

      {/* <NavbarSearch /> */}

      {/* <CartDropdown /> */}

      {/* <NotificationDropdown /> */}

      <UserDropdown />
    </ul>
  );
};
export default NavbarUser;
